import LogLevel from '../Contexts/Logging/LogLevel';

export default class ConsoleLog {
    constructor(logData: boolean, logLevel?: LogLevel) {
        this.logData = logData;
        this.logLevel = logLevel;
    }

    _log(level: LogLevel, eventName, data = {}) {
        if (!this.logLevel || level > this.logLevel) {
            // eslint-disable-next-line no-console
            console.log(
                `${level}: ${eventName ? `${eventName} - ` : ''}${
                    this.logData ? JSON.stringify(data) : ''
                }`
            );
        }
    }

    trace(eventName, data) {
        this._log(LogLevel.TRACE, eventName, data);
    }

    debug(eventName, data) {
        this._log(LogLevel.DEBUG, eventName, data);
    }

    info(eventName, data) {
        this._log(LogLevel.INFO, eventName, data);
    }

    warn(eventName, data) {
        this._log(LogLevel.WARN, eventName, data);
    }

    error(eventName, data) {
        this._log(LogLevel.ERROR, eventName, data);
    }

    fatal(eventName, data) {
        this._log(LogLevel.FATAL, eventName, data);
    }
}
